import Link from "next/link";

import { cn } from "@kit/ui/utils";

function LogoImage({ className }: { className?: string }) {
  return (
    <img
      className={cn(
        "mt-[-5px] h-[35px] w-auto hover:animate-spin-slow lg:h-[40px]",
        className,
      )}
      src="/images/logo.webp"
      alt="Content Flywheel"
    />
  );
}

export function AppLogo({
  href,
  label,
  className,
}: {
  href?: string;
  className?: string;
  label?: string;
}) {
  return (
    <Link aria-label={label ?? "Home Page"} href={href ?? "/"}>
      <LogoImage className={className} />
    </Link>
  );
}
